import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

import CreateOrgUserDialog from "./CreateUserDialog/CreateOrgUserDialog";

// ----------------------------------------------------------------------

export const CardHeader = () => {
	const [showCreateUserDialog, setShowCreateUserDialog] = useState(false);

	const { translate } = useLocales();

	return (
		<Stack
			flexDirection={{ xs: "column", sm: "row" }}
			alignItems={{ xs: "flex-start", sm: "center" }}
			justifyContent={{ xs: "center", sm: "space-between" }}
			p={3}
		>
			<Typography variant={"h6"}>{translate("organization.users")}</Typography>
			<Button
				startIcon={<Iconify icon='ic:round-plus' />}
				variant='contained'
				size='small'
				sx={{ mt: { xs: 2, sm: 0 } }}
				onClick={() => setShowCreateUserDialog(true)}
			>
				{translate("organization.invite_user")}
			</Button>
			<CreateOrgUserDialog
				show={showCreateUserDialog}
				onClose={() => setShowCreateUserDialog(false)}
			/>
		</Stack>
	);
};

export default CardHeader;
